/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1CsvExportConfig } from '../models/V1CsvExportConfig';
import { V1PdfExportConfig } from '../models/V1PdfExportConfig';
import { HttpFile } from '../http/http';

/**
* ExportConfig carries format-specific configuration for a Report. Exactly one arm of `variant` must be set, and the populated arm must match Report.export_type.
*/
export class V1ExportConfig {
    'csv'?: V1CsvExportConfig;
    'pdf'?: V1PdfExportConfig;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "csv",
            "baseName": "csv",
            "type": "V1CsvExportConfig",
            "format": ""
        },
        {
            "name": "pdf",
            "baseName": "pdf",
            "type": "V1PdfExportConfig",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ExportConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

